import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { language } from "language/default";
import { insFundSeriesListStateId } from "./fundSeriesList";
import { setMessagesDialog } from "store/messages-dialog";
import { useAllFundSeriesSelector } from "./api";
export const InsDeleteFundSeriesAction = () => {
    const dispatch = useDispatch();
    const selectedRows = useSelector((state) => state.grids.state[insFundSeriesListStateId]?.selectedRows, isEqual) ?? [];
    const allFundSeries = useAllFundSeriesSelector();
    const handleClick = () => {
        if (!selectedRows.length) {
            return;
        }
        const selectedNames = selectedRows
            .map((id) => allFundSeries.find((fs) => fs.id === id)?.name)
            .filter((name) => Boolean(name));
        const names = selectedNames.length === 1 ? selectedNames[0] : selectedNames.join(" and ");
        dispatch(setMessagesDialog({
            functionName: MessagesDialogFunctionName.DeleteFundSeries,
            hasCustomFooter: true,
            isPrimaryButtonDelete: true,
            messages: [
                { message: language.en.fundSeries.fundSeriesDeletion.deleteFundSeriesAlertFirstLine(names) },
                { message: language.en.fundSeries.fundSeriesDeletion.deleteFundSeriesAlertSecondLine }
            ],
            title: language.en.fundSeries.fundSeriesDeletion.deleteFundSeriesAlertHeader,
            type: "alert-with-options"
        }));
    };
    return React.createElement(AuxButton, { size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, isDisabled: selectedRows.length === 0, onClick: handleClick, label: language.en.fundSeries.fundSeriesDeletion.deleteFundSeries });
};
